import { useState } from 'react';
import { Link } from 'react-router-dom';

import { UpgradeModal } from '@/features/generation/components/UpgradeModal';
import { useAuth } from '@/providers/AuthProvider';
import { getWebUrl } from '@/lib/urls';
import { Badge, Button, Container } from '@pptcreate/ui';

export function AppHeader() {
  const { user, isAuthenticated, signOut } = useAuth();
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  const webUrl = getWebUrl();
  const accountUrl = `${webUrl}/account`;

  const showUpgradeCta =
    isAuthenticated &&
    user?.plan === 'free' &&
    user.quota.remainingFreeDecks !== null &&
    user.quota.remainingFreeDecks <= 0;

  return (
    <header className="border-b-[3px] border-brut-border bg-brut-surface">
      <Container className="flex items-center justify-between gap-4 py-4">
        <div className="flex items-center gap-6">
          <a
            href={webUrl}
            className="border-2 border-brut-border bg-brut-bg px-2 py-1 text-sm font-bold uppercase tracking-tight text-brut-fg no-underline shadow-brut-sm hover:bg-brut-fg hover:text-brut-surface"
          >
            pptcreate.app
          </a>
          <nav className="hidden items-center gap-4 text-sm sm:flex" aria-label="Main">
            <Link to="/generate" className="font-bold text-brut-fg no-underline hover:bg-brut-fg hover:text-brut-surface">
              Generate
            </Link>
            <Link to="/decks" className="font-bold text-brut-fg no-underline hover:bg-brut-fg hover:text-brut-surface">
              My decks
            </Link>
            <Link to="/templates" className="font-bold text-brut-fg no-underline hover:bg-brut-fg hover:text-brut-surface">
              Templates
            </Link>
          </nav>
        </div>

        <div className="flex items-center gap-3 text-sm">
          {isAuthenticated && user ? (
            <>
              <div className="hidden items-center gap-2 sm:flex">
                <span
                  className="flex h-8 w-8 items-center justify-center border-2 border-brut-border bg-brut-bg text-xs font-bold uppercase"
                  aria-hidden
                >
                  {user.email.slice(0, 1)}
                </span>
                <div className="text-right">
                  <p className="font-bold text-brut-fg">{user.email}</p>
                  <p className="text-xs text-brut-muted">
                    {user.plan === 'unlimited' ? (
                      'Unlimited plan'
                    ) : (
                      <>
                        {user.deckCount} of {user.quota.freeDeckLimit} decks used
                        {user.quota.remainingFreeDecks !== null
                          ? ` · ${user.quota.remainingFreeDecks} remaining`
                          : null}
                      </>
                    )}
                  </p>
                </div>
              </div>
              <Badge variant={user.plan === 'unlimited' ? 'accent' : 'default'}>
                {user.plan === 'unlimited' ? 'Unlimited' : 'Free'}
              </Badge>
              <a
                href={accountUrl}
                className="hidden font-bold text-brut-fg no-underline hover:bg-brut-fg hover:text-brut-surface lg:inline"
              >
                Account
              </a>
              {showUpgradeCta ? (
                <Button
                  type="button"
                  variant="primary"
                  size="sm"
                  onClick={() => setUpgradeOpen(true)}
                  className="hidden sm:inline-flex"
                >
                  Upgrade
                </Button>
              ) : null}
              <Button type="button" variant="secondary" size="sm" onClick={() => void signOut()}>
                Sign out
              </Button>
            </>
          ) : (
            <Link to="/login" className="no-underline">
              <Button variant="primary" size="sm">Sign in</Button>
            </Link>
          )}
        </div>
      </Container>

      <UpgradeModal open={upgradeOpen} onClose={() => setUpgradeOpen(false)} />
    </header>
  );
}
